//importing layouts....
import Admin from "layouts/Admin";
import UnAuth from "layouts/Auth";
import Dashboard from "views/Dashboard.js";
import Login from "./views/Login/Login";
import SiteSettings from "views/Settings/SiteSettings";
import Profile from "views/Profile/profile";
import Unauth from "layouts/Auth";
import ForgotPassword from "views/ForgotPassword/ForgotPassword";
import ResetPassword from "views/ResetPassword/ResetPassword";
import Permissions from "views/AdminStaff/permissions/permissionsListingComponent";
import Staff from "views/AdminStaff/staff/staffListingComponent";
import contentManagementSystem from "views/ContentManagment/contentManagementSystem";
import UpsertContent from "views/ContentManagment/upsertContent";
import ViewCMS from "views/ContentManagment/viewCMS";
import Categories from "views/Categories/categories";
import Documents from "views/Douments/documents";
import Gallery from "views/Gallery/gallery";
import TeamMembersListing from "views/TeamMembers/teamMembers";
import upsertEvent from "views/Events/upsertEvent";
import viewEvent from "views/Events/viewEvent";
import Events from "views/Events/events";
import Slider from "views/Slider/slider";
import About from "views/About/About";

import { 
  FaSignInAlt, FaChartPie, FaUser, FaLock, FaUsersCog, 
  FaList, FaImages, FaFileAlt, FaPen, FaFolder, FaEye ,
  FaCamera, FaUserTie, FaCalendarAlt, FaCogs, FaInfoCircle, FaHome
} from "react-icons/fa";

var routes = [
  {
    path: "/",
    layout: Unauth,
    name: "Login",
    icon: FaSignInAlt,
    access: true,
    exact: true,
    component: Login,
  },
  {
    path: "/dashboard",
    layout: Admin,
    name: "Dashboard",
    icon: FaHome,
    access: true,
    exact: true,
    component: Dashboard,
    showInSideBar: true,
  },
  {
    path: "/profile",
    layout: Admin,
    name: "Profile",
    icon: FaUser,
    access: true,
    exact: true,
    component: Profile,
    showInSideBar: false,
  },
  {
    collapse: true,
    name: "Admin Staff",
    state: "openAdminStaff",
    icon: FaUsersCog,
    showInSideBar: true,
    submenus: [
      {
        path: "/permissions",
        layout: Admin,
        name: "Permissions",
        icon: FaLock,
        access: true,
        exact: true,
        component: Permissions,
        showInSideBar: true,
      },
      {
        path: "/users-managment",
        layout: Admin,
        name: "User Managment",
        icon: FaUserTie,
        access: true,
        exact: true,
        component: Staff,
        showInSideBar: true,
      },
    ],
  },
  {
    path: "/categories",
    layout: Admin,
    name: "Categories",
    icon: FaList,
    access: true,
    exact: true,
    component: Categories,
    showInSideBar: true,
  },
  {
    path: "/slider",
    layout: Admin,
    name: "Slider",
    icon: FaImages,
    access: true,
    exact: true,
    component: Slider,
    showInSideBar: true,
  },
  {
    path: "/cms",
    layout: Admin,
    name: "Content",
    icon: FaFileAlt,
    access: true,
    exact: true,
    component: contentManagementSystem,
    showInSideBar: true,
  },
  {
    path: "/add-cms",
    layout: Admin,
    name: "Add Content",
    icon: FaPen,
    access: true,
    exact: true,
    component: UpsertContent,
  },
  {
    path: "/edit-cms/:contentId",
    layout: Admin,
    name: "Edit Content",
    icon: FaPen,
    access: true,
    exact: true,
    component: UpsertContent,
  },
  {
    path: "/view-cms/:contentId",
    layout: Admin,
    name: "CMS",
    icon: FaFileAlt,
    access: true,
    exact: true,
    component: ViewCMS,
  },
  {
    path: "/documents",
    layout: Admin,
    name: "Documents",
    icon: FaFolder,
    access: true,
    exact: true,
    component: Documents,
    showInSideBar: true,
  },
  {
    path: "/gallery",
    layout: Admin,
    name: "Gallery",
    icon: FaCamera,
    access: true,
    exact: true,
    component: Gallery,
    showInSideBar: true,
  },
  {
    path: "/team",
    layout: Admin,
    name: "Team Members",
    icon: FaUserTie,
    access: true,
    exact: true,
    component: TeamMembersListing,
    showInSideBar: true,
  },
  {
    path: "/events",
    layout: Admin,
    name: "Events",
    icon: FaCalendarAlt,
    access: true,
    exact: true,
    component: Events,
    showInSideBar: true,
  },
  {
    path: "/add-event",
    layout: Admin,
    name: "Add Event",
    icon: FaPen,
    access: true,
    exact: true,
    component: upsertEvent,
  },
  {
    path: "/edit-event/:contentId",
    layout: Admin,
    name: "Edit Event",
    icon: FaPen,
    access: true,
    exact: true,
    component: upsertEvent,
  },
  {
    path: "/view-event/:contentId",
    layout: Admin,
    name: "View Event",
    icon: FaEye,
    access: true,
    exact: true,
    component: viewEvent,
  },
  {
    path: "/site-settings",
    layout: Admin,
    name: "Settings",
    icon: FaCogs,
    access: true,
    exact: true,
    component: SiteSettings,
    showInSideBar: true,
  },
  {
    path: "/about",
    layout: Admin,
    name: "About",
    icon: FaInfoCircle,
    access: true,
    exact: true,
    component: About,
    showInSideBar: true,
  },
  {
    path: "/login",
    layout: UnAuth,
    name: "Login",
    mini: "LP",
    component: Login,
  },
  {
    path: "/forgot-password",
    layout: UnAuth,
    name: "Forgot Passowrd",
    mini: "FP",
    component: ForgotPassword,
  },
  {
    path: "/reset-password/:adminId/:code",
    layout: UnAuth,
    name: "Reset Passowrd",
    mini: "RP",
    component: ResetPassword,
  },
];

export default routes;
